  <div class="logout-page d-flex justify-content-center align-items-center vh-100">
    <div class="text-center">
      <h3>Logging out...</h3>
      <p>Please wait while we redirect you.</p>
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>


